import { InjectionKey } from 'vue';
import { LoginContext } from '@/common/domain/login/LoginContext';

export const loginContextRepositoryKey: InjectionKey<LoginContextRepository> = Symbol();

export interface LoginContextRepository {
  storeLoginContext(context: LoginContext): void;
  retrieveLoginContext(): LoginContext;
}
